import { render } from "./user-dashboard-filter.vue?vue&type=template&id=4b200317"
import script from "./user-dashboard-filter.vue?vue&type=script&lang=js"
export * from "./user-dashboard-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__